var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "box view-nav-bar" }, [
        _c("div", { staticClass: "d-flex align-items-center w-100" }, [
          _c(
            "div",
            { staticClass: "flex-grow-1" },
            [
              _c(
                "router-link",
                { staticClass: "mr-3", attrs: { to: "/admissions/movie" } },
                [
                  _c("icon", { attrs: { name: "chevron-left" } }),
                  _vm._v(" Back\n                "),
                ],
                1
              ),
              _vm._v(" "),
              _c("strong", [_vm._v("Per movie")]),
              _vm._v(" "),
              _c("span", { staticClass: "text-muted ml-2" }, [
                _vm._v("— cinema year "),
                _c("strong", [_vm._v(_vm._s(_vm.year))]),
                _vm._v(
                  ", top " +
                    _vm._s(_vm.bucket.top || 100) +
                    " movies, all sessions vs. Brightfish preshow"
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-inline" },
            [
              _c(
                "label",
                {
                  staticClass: "text-muted mr-2",
                  attrs: { for: "tag-filter" },
                },
                [_vm._v("Tag")]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.tag,
                      expression: "tag",
                    },
                  ],
                  staticClass: "form-control form-control-sm mr-3",
                  attrs: {
                    id: "tag-filter",
                    disabled: _vm.loading || !_vm.tags.length,
                  },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.tag = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("All tags")]),
                  _vm._v(" "),
                  _vm._l(_vm.tags, function (t) {
                    return _c(
                      "option",
                      {
                        key: t.movie_tag || "none",
                        domProps: { value: t.movie_tag || "none" },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.tagLabel(t.movie_tag)) +
                            " (" +
                            _vm._s(t.movies) +
                            " movies, " +
                            _vm._s(_vm.formatInt(t.admissions)) +
                            ")\n                    "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "btn btn-sm btn-outline-secondary mr-2",
                  attrs: {
                    to: {
                      path:
                        "/admissions/movie/year/" +
                        (parseInt(_vm.year, 10) - 1),
                      query: _vm.$route.query,
                    },
                  },
                },
                [
                  _c("icon", { attrs: { name: "chevron-left" } }),
                  _vm._v(
                    " " +
                      _vm._s(parseInt(_vm.year, 10) - 1) +
                      "\n                "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "btn btn-sm btn-outline-secondary",
                  attrs: {
                    to: {
                      path:
                        "/admissions/movie/year/" +
                        (parseInt(_vm.year, 10) + 1),
                      query: _vm.$route.query,
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(parseInt(_vm.year, 10) + 1) +
                      " "
                  ),
                  _c("icon", { attrs: { name: "chevron-right" } }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content text-center text-muted py-4" },
              [_vm._v("Loading…")]
            ),
          ])
        : !_vm.totals
        ? _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content text-center text-muted py-4" },
              [_vm._v("No admissions in cinema year " + _vm._s(_vm.year) + ".")]
            ),
          ])
        : [
            _c("div", { staticClass: "box" }, [
              _c("div", { staticClass: "box-content" }, [
                _c("table", { staticClass: "shx-table w-100 mt-2" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(_vm._s(_vm.formatInt(_vm.totals.admissions))),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.totals.weeks
                              ? _vm.formatInt(
                                  _vm.totals.admissions / _vm.totals.weeks
                                )
                              : "—"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [_vm._v("100%")]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(_vm._s(_vm.totals.weeks)),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(_vm._s(_vm.totals.cinemas)),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(_vm._s(_vm.totals.movies)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(
                          _vm._s(_vm.formatInt(_vm.totals.admissions_preshow))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.totals.weeks
                              ? _vm.formatInt(
                                  _vm.totals.admissions_preshow /
                                    _vm.totals.weeks
                                )
                              : "—"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.totals.pct_preshow !== null
                              ? _vm.totals.pct_preshow + "%"
                              : "—"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { colspan: "3" } }),
                    ]),
                    _vm._v(" "),
                    _vm.totals.tag
                      ? _c("tr", [
                          _c("td", [
                            _c("strong", [
                              _vm._v(
                                "Tag " +
                                  _vm._s(_vm.tagLabel(_vm.totals.tag.movie_tag))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "text-muted small ml-2" },
                              [_vm._v("all sales houses")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(_vm.formatInt(_vm.totals.tag.admissions))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.totals.weeks
                                  ? _vm.formatInt(
                                      _vm.totals.tag.admissions /
                                        _vm.totals.weeks
                                    )
                                  : "—"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.totals.tag.pct !== null
                                  ? _vm.totals.tag.pct + "%"
                                  : "—"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "2" } }),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(_vm._s(_vm.totals.tag.movies)),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "box" }, [
              _c(
                "div",
                { staticClass: "box-content" },
                [
                  _c("heading", {
                    attrs: {
                      upper: "Top movies",
                      lower:
                        "Top " +
                        _vm.rows.length +
                        " of " +
                        (_vm.totals.tag
                          ? _vm.totals.tag.movies +
                            " " +
                            _vm.tagLabel(_vm.totals.tag.movie_tag)
                          : _vm.totals.movies) +
                        " movies by admissions in " +
                        _vm.year +
                        ", all sales houses",
                      border: "",
                    },
                  }),
                  _vm._v(" "),
                  _vm.tag && !_vm.rows.length
                    ? _c("p", { staticClass: "text-muted small mt-2 mb-0" }, [
                        _vm._v(
                          "No movies with tag " +
                            _vm._s(
                              _vm.tagLabel(_vm.tag === "none" ? null : _vm.tag)
                            ) +
                            " in " +
                            _vm._s(_vm.year) +
                            "."
                        ),
                      ])
                    : _c("table", { staticClass: "shx-table w-100 mt-2" }, [
                        _vm._m(3),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.rows, function (movie, index) {
                            return _c("tr", { key: movie.movix_id }, [
                              _c("td", { staticClass: "text-muted" }, [
                                _vm._v(_vm._s(index + 1)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to:
                                          "/admissions/movie/" + movie.movix_id,
                                      },
                                    },
                                    [_vm._v(_vm._s(movie.movix_id))]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to:
                                          "/admissions/movie/" + movie.movix_id,
                                      },
                                    },
                                    [_vm._v(_vm._s(movie.title || "—"))]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    class: { "text-muted": !movie.movie_tag },
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.tag = movie.movie_tag || "none"
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.tagLabel(movie.movie_tag))
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(_vm._s(movie.weeks)),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(_vm._s(_vm.formatInt(movie.admissions))),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    movie.pct !== null ? movie.pct + "%" : "—"
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-right text-muted" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.pct(
                                        _vm.cumulative[index],
                                        _vm.totals.admissions
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatInt(movie.admissions_preshow)
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    movie.pct_preshow !== null
                                      ? movie.pct_preshow + "%"
                                      : "—"
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      movie.real_weighted != null
                                        ? movie.real_weighted + "%"
                                        : "—"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                movie.real_weighted != null &&
                                movie.real_weighted <= 90
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "badge badge-warning ml-1",
                                      },
                                      [_vm._v("⚠")]
                                    )
                                  : _vm._e(),
                              ]),
                            ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("tfoot", [
                          _c("tr", [
                            _c("td", { attrs: { colspan: "5" } }, [
                              _c("strong", [
                                _vm._v("Top " + _vm._s(_vm.rows.length)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.formatInt(_vm.topAdmissions))
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.pct(
                                      _vm.topAdmissions,
                                      _vm.totals.admissions
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td"),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.formatInt(_vm.topPreshow))),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.pct(
                                      _vm.topPreshow,
                                      _vm.totals.admissions_preshow
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td"),
                          ]),
                        ]),
                      ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-muted small mt-2 mb-0" }, [
                    _c("strong", [_vm._v("Admissions")]),
                    _vm._v(" = every "),
                    _c("code", [_vm._v("admissions_week")]),
                    _vm._v(
                      " row of the movie, whatever the sales house;\n                    "
                    ),
                    _c("strong", [_vm._v("Preshow")]),
                    _vm._v(" = rows with "),
                    _c("code", [_vm._v("saleshouse = BF")]),
                    _vm._v(
                      ". The year totals include titles without\n                    a Movix id, so the shares are of everything reported in " +
                        _vm._s(_vm.year) +
                        ", also when filtered on a tag.\n                    "
                    ),
                    _c("strong", [_vm._v("Tag")]),
                    _vm._v(" is the Movix target pack from "),
                    _c("code", [_vm._v("movix_history")]),
                    _vm._v("; click one to filter.\n                    "),
                    _c("strong", [_vm._v("Real %")]),
                    _vm._v(
                      " is the\n                    admissions-weighted average of "
                    ),
                    _c("code", [_vm._v("real")]),
                    _vm._v(
                      ": 97.5 = fully compiled from Cinedata, lower = partly estimated.\n                    Same data as JSON: "
                    ),
                    _c("code", [
                      _vm._v(
                        "GET /api/v1/admissions/movie/year/" + _vm._s(_vm.year)
                      ),
                      _vm.tag
                        ? _c("span", [_vm._v("?tag=" + _vm._s(_vm.tag))])
                        : _vm._e(),
                    ]),
                    _vm._v(".\n                "),
                  ]),
                ],
                1
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Admissions")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("Avg / week"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("% of all"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("# Weeks")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("# Cinemas"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("# Movies"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("strong", [_vm._v("All sessions")]),
      _vm._v(" "),
      _c("span", { staticClass: "text-muted small ml-2" }, [
        _vm._v("every title, every sales house"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("strong", [_vm._v("Preshow sessions")]),
      _vm._v(" "),
      _c("span", { staticClass: "text-muted small ml-2" }, [
        _vm._v("sales house BF"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "shx-th-50" }, [_vm._v("#")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-80" }, [_vm._v("Movix")]),
        _vm._v(" "),
        _c("th", [_vm._v("Title")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-120" }, [_vm._v("Tag")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("# Weeks")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Admissions")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("% of year"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("Cumul. %"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("Preshow (BF)"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("% of preshow"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("Real %")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }